import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "617.51",
  x2: "100",
  y2: "757",
  gradientTransform: "translate(0 -567)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M175.4 190h-10.2s0-20.8-22-45c5.9 14.7 9.3 32.9 10.2 45h-28c-3.4-6.9-7.6-14.7-15.3-22.5 2.5 6.9 5.1 14.7 6.8 22.5H23.7c-.8-3.5-.8-7.8-.8-11.2 0-28.6 15.3-53.7 38.1-67.5h78c22.9 13.8 38.1 38.1 38.1 67.5 0 3.4-.8 6.9-1.7 11.2zM122 100H78c-5.9 0-11-5.2-11-11.3V77.6c0-6.1 5.1-11.3 11-11.3h11v-45c0-6.1 5.1-11.3 11-11.3s11 5.2 11 11.3v45h11c5.9 0 11 5.2 11 11.3v11.2c.1 6.1-5 11.2-11 11.2z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}